import { Box, Skeleton, useTheme } from '@mui/material';
import Grid from '@mui/material/Grid2';

export default function RevenueLoader() {
  const theme = useTheme();

  return (
    <>
      <Grid container spacing={3} mb={3} mt={2}>
        {[1, 2, 3, 4].map((idx) => (
          <Grid key={`skeleton-card-${idx}`} size={{ xs: 12, sm: 6, md: 3 }}>
            <Box
              bgcolor='#fff'
              border='1px solid #ECECEC'
              p={2}
              borderRadius='10px'
              display='flex'
              flexDirection='column'
              justifyContent='space-between'
              minHeight={120}
            >
              {/* Title + Icon */}
              <Box display='flex' justifyContent='space-between' alignItems='center' mb={1}>
                <Skeleton variant='text' width={100} height={20} />
                <Skeleton variant='circular' width={36} height={36} sx={{ bgcolor: theme.palette.action.hover }} />
              </Box>

              {/* Big Number */}
              <Skeleton variant='text' width={80} height={36} />
            </Box>
          </Grid>
        ))}
      </Grid>

      {/* Revenue Breakdown Table */}
      <Box bgcolor={theme.palette.background.paper} padding={3} mb={3}>
        <Skeleton variant='text' width={200} height={28} sx={{ mb: 2 }} />
        <Skeleton variant='rectangular' width='100%' height={400} sx={{ borderRadius: 1 }} />
      </Box>

      {/* Two Charts */}
      <Grid container spacing={3}>
        <Grid size={{ xs: 12, lg: 6 }} bgcolor={theme.palette.background.paper} padding={3}>
          <Skeleton variant='text' width={180} height={28} sx={{ mb: 2 }} />
          <Skeleton variant='circular' width={200} height={200} sx={{ mx: 'auto', display: 'block' }} />
        </Grid>
        <Grid size={{ xs: 12, lg: 6 }} bgcolor={theme.palette.background.paper} padding={3}>
          <Skeleton variant='text' width={160} height={28} sx={{ mb: 2 }} />
          <Skeleton variant='circular' width={200} height={200} sx={{ mx: 'auto', display: 'block' }} />
        </Grid>
      </Grid>
    </>
  );
}
